import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { enableScrolling, disableScrolling } from '../services/Viewport/scroll'
import support from '../utils/BrowserSupport'
import keycode from 'keycode'
import { removeComponents, loadComponents } from '../core/componentUtils'

export const STATES = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible',
    LOADING: 'is-loading',
    FULLSCREEN: 'is-fullscreen'
}

export default class Modal extends Component {
    constructor(element, options = {}) {
        super(element, {
            dispose: false,
            active: false,
            url: null,
            className: '',
            fullscreen: false,
            netteCloseOn: null,
            autoOpen: false,
            filterResponse: function(html) { return {content: html} }
        })

        this.ref = {
            background: null,
            layer: null,
            content: null,
            inner: null,
            closeButton: null
        }

        this.options = options

        if (this.options.className) {
            this.element.classList.add(...this.options.className.split(' '))
        }

        if (this.options.fullscreen) {
            this.element.classList.add(STATES.FULLSCREEN)
        }

        if (this.options.content) {
            this.setContent(this.options.content)
        }

        this.handleKeyDown = ::this.handleKeyDown
        this.request = null
    }

    prepare() {
        if (this.ref.closeButton) {
            this.ref.closeButton.addEventListener('click', this.handleCloseClick)
        }

        this.element.addEventListener(support.transitionEnd, event => {
            if (event.target === this.element && !this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)

                if (this.options.dispose) {
                    removeComponents(this.ref.content)
                    this.destroy()
                    this.element.parentNode.removeChild(this.element)
                    this.element = null
                }
            }
        })

        this.element.addEventListener('click', ::this.handleOuterClick)

        if (this.options.autoOpen) {
            if (this.options.url) {
                this.load()
            } else {
                this.open()
            }
        }
    }

    destroy() {
        document.removeEventListener('keydown', this.handleKeyDown)
        if (this.request) {
            this.request.abort()
        }
    }

    handleCloseClick = event => {
        event.preventDefault()
        this.close()
    }

    handleOuterClick(event) {
        if (!event.target || !document.body.contains(event.target)) {
            return
        }

        if (!this.ref.content.contains(event.target)) {
            this.close()
        }
    }

    handleClick(event) {
        event.preventDefault()
        this.close()
    }

    handleKeyDown(event) {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    handleNetteEvent = data => {
        const closeOn = JSON.stringify(this.options.netteCloseOn)
        const action = JSON.stringify(data)

        if (closeOn === action) {
            this.close()
        }
    }

    open() {
        disableScrolling()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)

        document.addEventListener('keydown', this.handleKeyDown)

        this.emit('open', {
            id: this.element.id
        })

        EventBus.emit('modal:open', {
            id: this.element.id
        })

        if (this.options.url) {
            this.load()
        }

        EventBus.on('nette:event', this.handleNetteEvent)

    }

    close() {
        if (this.request) {
            this.request.abort()
        }

        enableScrolling()
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeyDown)

        this.emit('close', {
            id: this.element.id
        })

        EventBus.emit('modal:close', {
            id: this.element.id
        })

        EventBus.off('nette:event', this.handleNetteEvent)
    }

    load() {
        this.element.classList.add(STATES.LOADING)
        this.request = $.ajax({
            url: this.options.url,
            dataType: 'HTML',
            success: response => {
                const data = this.options.filterResponse(response)

                if ('title' in data) {
                    this.setTitle(data.title)
                }

                if ('content' in data) {
                    this.setContent(data.content)
                }
            },
            complete: () => {
                this.element.classList.remove(STATES.LOADING)

                if (this.options.autoOpen) {
                    this.open()
                }
            }
        })
    }

    setTitle(title) {
        if (!this.ref.header) {
            this.ref.header = document.createElement('div')
            this.ref.header.classList.add('Modal-header')
            this.ref.inner.insertBefore(this.ref.header, this.ref.content)
        }

        this.ref.header.innerHTML = `<h2 class="Modal-title">${title}</h2>`
    }

    setContent(html) {
        removeComponents(this.ref.content)
        this.ref.content.innerHTML = html
        loadComponents(this.ref.content)
        $.nette.load()
    }

    isOpen() {
        return this.is(STATES.ACTIVE)
    }
}

const template = `
    <div class="Modal-background" data-ref="background"></div>
    <div class="Modal-layer" data-ref="layer">
        <div class="Modal-inner" data-ref="inner">
            <div class="Modal-content" data-ref="content">
            </div>
            <button type="button" class="Modal-close" data-ref="closeButton">Zavřít</button>
        </div>
    </div>
`

export function createModal(options) {
    const element = document.createElement('div')
    element.classList.add('Modal')
    element.innerHTML = template
    document.body.appendChild(element)

    const modal = new Modal(element, {
        dispose: true,
        ...options
    })
    modal.prepare()

    return modal
}
